/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2022-10-27 16:05:36
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2022-10-31 17:34:26
 * @FilePath     : /ticket-plat-frontend/src/router/convert/routerConfig.ts
 */
import Config from '@/config';

export enum Platform {
    Mobile = 'mobile',
    Pc = 'pc',
};

export interface RouterPath {
    [propName: string]: string;
    ticketCreate: string;
    ticketList: string;
}

export interface RouterParams {
    productId?: string;
    questionId?: string;
    channel?: string;
    useticket?: string;
    createDirectly?: string;
    requestId?: string;
    module?: string;
    fromConsole?: string;
    templateName?: string;
}

// 不同端路由映射关系，包含协议、host、路径、参数
// 主要用于解决，多端同一页面的路径不一致问题
export interface RouterConfig {
    platform: Platform;
    protocol: string;
    host: string;
    path: RouterPath;
    params: RouterParams;
}

export const MobileRouterConfig: RouterConfig = {
    platform: Platform.Mobile,
    protocol: 'https',
    host: Config.MOBILE_TICKET_HOST,
    path: {
        default: '/ticket/h5/index.html',
        index: '/ticket/h5/index.html',
        ticketCreate: '/ticket/h5/index.html#/pages/workOrder/createOrder',
        ticketList: '/ticket/h5/index.html',
    },
    params: {},
};

export const PcRouterConfig: RouterConfig = {
    platform: Platform.Pc,
    protocol: 'https',
    host: Config.MOBILE_TICKET_HOST,
    path: {
        default: '',
        index: '#/',
        ticketCreate: '#/ticket/create',
        ticketList: '#/ticket/list',
    },
    params: {
        productId: 'productId',
        questionId: 'questionId',
        channel: 'channel',
        useticket: 'useticket',
        createDirectly: 'createDirectly',
        requestId: 'requestId',
        module: 'module',
        fromConsole: 'fromConsole',
        templateName: 'templateName',
    },
};
